import _Promise from 'babel-runtime/core-js/promise';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _Object$entries from 'babel-runtime/core-js/object/entries';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

var _this = this;

var addUploadFeature = function addUploadFeature(requestHandler) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, resource, params) {
      var newParams, _iterator, _isArray, _i, _ref2, _ref3, key, value;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(type === 'UPDATE' || type === 'CREATE')) {
                _context.next = 25;
                break;
              }

              newParams = {};
              _iterator = _Object$entries(params.data), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);

            case 3:
              if (!_isArray) {
                _context.next = 9;
                break;
              }

              if (!(_i >= _iterator.length)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('break', 24);

            case 6:
              _ref2 = _iterator[_i++];
              _context.next = 13;
              break;

            case 9:
              _i = _iterator.next();

              if (!_i.done) {
                _context.next = 12;
                break;
              }

              return _context.abrupt('break', 24);

            case 12:
              _ref2 = _i.value;

            case 13:
              _ref3 = _ref2, key = _ref3[0], value = _ref3[1];

              if (!Array.isArray(value)) {
                _context.next = 18;
                break;
              }

              _context.next = 17;
              return convertToArrayOfBase64Objects(value);

            case 17:
              newParams[key] = _context.sent;

            case 18:
              if (!(value && value.rawFile instanceof File)) {
                _context.next = 22;
                break;
              }

              _context.next = 21;
              return convertToBase64Object(value);

            case 21:
              newParams[key] = _context.sent;

            case 22:
              _context.next = 3;
              break;

            case 24:
              params.data = _extends({}, params.data, newParams);

            case 25:
              return _context.abrupt('return', requestHandler(type, resource, params));

            case 26:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};

var convertFileToBase64 = function convertFileToBase64(file) {
  return new _Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file.rawFile);

    reader.onload = function () {
      return resolve(reader.result);
    };

    reader.onerror = reject;
  });
};

var convertToBase64Object = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return convertFileToBase64(file);

          case 2:
            _context2.t0 = _context2.sent;
            _context2.t1 = '' + file.title;
            return _context2.abrupt('return', {
              src: _context2.t0,
              title: _context2.t1
            });

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function convertToBase64Object(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

var convertToArrayOfBase64Objects = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(array) {
    var formerFields, newFiles, transformedNewFiles;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            formerFields = array.filter(function (p) {
              return !(p.rawFile instanceof File);
            });
            newFiles = array.filter(function (p) {
              return p.rawFile instanceof File;
            });
            _context3.next = 4;
            return _Promise.all(newFiles.map(convertToBase64Object));

          case 4:
            transformedNewFiles = _context3.sent;
            return _context3.abrupt('return', [].concat(transformedNewFiles, formerFields));

          case 6:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function convertToArrayOfBase64Objects(_x5) {
    return _ref5.apply(this, arguments);
  };
}();

export default addUploadFeature;